<template>
  <div class="news" :class="{ firstPage: firstPage }">
    <div class="newsHeaderNav">
      <div class="headerContainer">
        <div class="headerTitle">{{ mainTitle }}</div>
        <div class="headerBackBtn" @click="routeBackHandler">
          <i class="fas fa-arrow-left" style="font-size: 24px"></i>
        </div>
      </div>
    </div>
    <div class="newsContainer">
      <div class="newsHeader">
        <Skeletor
          v-if="loadingSkeletor"
          class="newsMainThumb"
          style="background: rgb(163, 219, 213)"
        />
        <router-link
          class="newsMainThumb"
          v-if="!loadingSkeletor && article.special"
          :to="'/news-details?id=' + article.special.id"
        >
          <div class="thumbPic">
            <img :src="article.special.img" alt="" />
          </div>
          <div class="thumbContent">
            <div class="contentTitle">
              {{ article.special.title }}
            </div>
            <div class="contentMain" v-html="article.special.content"></div>
            <div class="contentLink">مطالعه بیشتر</div>
          </div>
        </router-link>
      </div>
      <div class="newsMain">
        <div class="newsList">
          <div v-if="loadingSkeletor && article.list.length == 0">

              <Skeletor
              v-for="i in 8"
              :key="i"
                class="newsThumbSkeletor"
                style="background: rgb(163, 219, 213)"
              />
          </div>
          <div class="listWrapper" v-if="!loadingSkeletor && article.list.length > 0">
            <router-link
              v-for="(v, i) in article.list"
              :key="i"
              :to="'/news-details?id=' + v.id"
              class="newsThumb"
            >
              <div class="thumbPic">
                <img :src="v.img" alt="" />
              </div>
              <div class="thumbContent">
                <div class="contentMain">
                  <div v-if=" v.sub_cat " class="contentCat">
                    {{ v.sub_cat }}
                  </div>
                  <div class="contentTitle">
                    {{ v.title }}
                  </div>
                  <div class="contentDesc" v-html="v.content"></div>
                  <div class="uploadDetailsWrapper">
                    <div class="uploadDate">
                      <div class="dateIcon">
                        <i class="far fa-clock"></i>
                      </div>
                      <div class="dateTitle">{{ v.created_fa }}</div>
                    </div>
                    <div class="veiwsNum">
                    <div class="numIcon">
                      <i class="far fa-eye"></i>
                    </div>
                    <div class="num">{{ v.view }} بازدید</div>
                  </div>
                  </div>
                </div>
                <!-- <div class="contentFooter">
                  <div class="readMoreLink">
                    <div class="linkIcon">
                      <VsxIcon
                        iconName="HambergerMenu"
                        :size="16"
                        color="#000"
                        type="linear"
                      />
                    </div>
                    <div class="linkeTitle">مطالعه بیشتر</div>
                  </div>
                  <div class="veiwsNum">
                    <div class="numIcon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                      </svg>
                    </div>
                    <div class="num">{{ v.view }} بازدید</div>
                  </div>
                </div> -->
              </div>
            </router-link>
          </div>

          <div
            v-if="!loadingSkeletor && article.list.length == 0"
            class="no-result"
          >
            <img src="@/assets/img/notfound.png" width="320" height="280" />
            <p>نتیجه ای یافت نشد</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeletor } from "vue-skeletor";
export default {
  name: "newsPage",
  components: { Skeletor },
  data() {
    return {
      loadingSkeletor: true,
      mainTitle: "",
      article: {
        firstPage: false,
        hasMorePages: true,
        lazyLoading: false,
        loading: true,
        page: 1,
        list: [],
        special: [],
      },
    };
  },
  mounted() {
    const routePrev = sessionStorage.getItem("prevPage");
    if (routePrev == "firstPage") {
      this.firstPage = true;
    } else {
      this.firstPage = false;
    }

    window.addEventListener("scroll", this.handleScroll);

    this.getarticle();
    this.mainTitleHandler();
  },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // },

  methods: {
    routeBackHandler() {
      history.back();
    },
    mainTitleHandler() {
      this.mainTitle=  this.$route.query.title;

    },
    handleScroll() {
      if (this.article.lazyLoading || !this.article.hasMorePages) return;

      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;

      const scrollPosition = scrollTop + windowHeight;

      if (scrollPosition >= docHeight * 0.9) {
        this.loadMore();
      }
    },

    async loadMore() {
      if (this.article.hasMorePages && !this.article.lazyLoading) {
        this.article.lazyLoading = true;
        this.article.page++;
        await this.getarticle();
        this.article.lazyLoading = false;
      }
    },
    getarticle: function () {
      let self = this;
      this.article.loading = true;
      self.article.hasMorePages = false;
      this.helperPost("get-article", {
        page: self.article.page,
        cat_id: self.$route.query.id
      })
        .then(function (r) {
          const result = r.data;
          if (result.result === "1") {
            const list = result.data.list;
            const totalPage = parseInt(result.data.total_page);
            const currentPage = parseInt(self.article.page);
            if (currentPage > 1) {
              self.article.list = [...self.article.list, ...list];
            } else {
              // برگشت به بالا در اسکرول‌بار
              const scrollbar = window.scroll;
              if (scrollbar) scrollbar.scrollTop = 0;

              self.article.list = list;
              self.article.special = result.data.special;
            }

            self.article.hasMorePages = currentPage < totalPage;
          } else {
            self.article.hasMorePages = false;
          }
          self.article.loading = false;
          self.loadingSkeletor = false;

          console.log("self.article.list", self.article.list);
        })
        .catch(function (err) {
          console.error("Error loading orders:", err);
          self.article.loading = false;
          self.article.hasMorePages = false;
        });
    },
  },
};
</script>
<srtyle scoped>
.no-result {
text-align: center;
margin-top: 5rem;
}
</srtyle>
